import React from 'react';
import useTranslation from '../../../../../../../../hooks/translation/useTranslation';

const listClass = 'flex flex-col gap-[14px] text-sm list-none p-0';
function PurchasedTicketPanelContent({
  tickets,
  handleTicketRefund,
  handleAdditionalServices,
  expired = false,
}) {
  const { trans } = useTranslation();
  return (
    <div className="flex gap-10 flex-wrap">
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('passenger(s)')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            {ticket.passenger}
          </li>
        ))}
      </ul>
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('document/personal')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            {ticket.document_code}
          </li>
        ))}
      </ul>
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('wagon')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            {ticket.wagon_number}
          </li>
        ))}
      </ul>
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('seat')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            {ticket.seat_number}
          </li>
        ))}
      </ul>
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('seat_class')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            {ticket.seat_class}
            {' '}
            (
            {trans(ticket.type.toLowerCase())}
            )
          </li>
        ))}
      </ul>
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('ticket_number')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            {ticket.ticket_number}
          </li>
        ))}
      </ul>

      <ul className={listClass}>
        <li className="font-bold text-black">{trans('refund')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-gray-gr ${ticket?.is_refunded && 'text-primary'}`}
          >
            <button
              type="button"
              className={`bg-transparent border-none flex gap-2 p-0 items-center ${
                !ticket?.is_refunded && 'cursor-pointer'
              }`}
              onClick={() => handleTicketRefund(ticket, tickets)}
              disabled={ticket?.is_refunded}
            >
              {!ticket?.is_refunded && <div className="cross" />}
              {trans(ticket?.is_refunded ? 'refunded' : 'refund')}
            </button>
          </li>
        ))}
      </ul>
      {handleAdditionalServices && !expired && (
        <ul className={listClass}>
          <li className="font-bold text-black">
            {trans('additional_services')}
          </li>
          {tickets.map((ticket) => (
            <li key={ticket.id} className="text-gray-gr">
              <button
                type="button"
                className="bg-transparent border-none flex gap-2 p-0 items-center cursor-pointer"
                onClick={() => handleAdditionalServices(ticket)}
              >
                {trans('see/add')}
              </button>
            </li>
          ))}
        </ul>
      )}
      <ul className={listClass}>
        <li className="font-bold text-black">{trans('price')}</li>
        {tickets.map((ticket) => (
          <li
            key={ticket.id}
            className={`text-black font-bold ${
              ticket?.is_refunded && 'text-primary'
            }`}
          >
            {ticket.price}
            {' '}
            {trans('gel')}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PurchasedTicketPanelContent;
